import React from "react";
import { Particles as ReactParticles } from "react-tsparticles";
import options from "../Config/Particles.json";

export default function Particles() {
  return (
    <div className="particle-container">
      <ReactParticles options={options} height={"91vh"} />
    </div>
  );
}
